import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { rotatePoints, rotateLines } from '../geometry';
export function polygonHachureLines(polygonList, o) {
  var angle = o.hachureAngle + 90;
  var gap = o.hachureGap;

  if (gap < 0) {
    gap = o.strokeWidth * 4;
  }

  gap = Math.max(gap, 0.1);
  var rotationCenter = [0, 0];

  if (angle) {
    var _iterator = _createForOfIteratorHelper(polygonList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var polygon = _step.value;
        rotatePoints(polygon, rotationCenter, angle);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  var lines = straightHachureLines(polygonList, gap);

  if (angle) {
    var _iterator2 = _createForOfIteratorHelper(polygonList),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _polygon = _step2.value;
        rotatePoints(_polygon, rotationCenter, -angle);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    rotateLines(lines, rotationCenter, -angle);
  }

  return lines;
}

function straightHachureLines(polygonList, gap) {
  var vertexArray = [];

  var _iterator3 = _createForOfIteratorHelper(polygonList),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var polygon = _step3.value;

      var _vertices = _toConsumableArray(polygon);

      if (_vertices[0].join(',') !== _vertices[_vertices.length - 1].join(',')) {
        _vertices.push([_vertices[0][0], _vertices[0][1]]);
      }

      if (_vertices.length > 2) {
        vertexArray.push(_vertices);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var lines = [];
  gap = Math.max(gap, 0.1); // Create sorted edges table

  var edges = [];

  for (var _i = 0, _vertexArray = vertexArray; _i < _vertexArray.length; _i++) {
    var vertices = _vertexArray[_i];

    for (var i = 0; i < vertices.length - 1; i++) {
      var p1 = vertices[i];
      var p2 = vertices[i + 1];

      if (p1[1] !== p2[1]) {
        var ymin = Math.min(p1[1], p2[1]);
        edges.push({
          ymin: ymin,
          ymax: Math.max(p1[1], p2[1]),
          x: ymin === p1[1] ? p1[0] : p2[0],
          islope: (p2[0] - p1[0]) / (p2[1] - p1[1])
        });
      }
    }
  }

  edges.sort(function (e1, e2) {
    if (e1.ymin < e2.ymin) {
      return -1;
    }

    if (e1.ymin > e2.ymin) {
      return 1;
    }

    if (e1.x < e2.x) {
      return -1;
    }

    if (e1.x > e2.x) {
      return 1;
    }

    if (e1.ymax === e2.ymax) {
      return 0;
    }

    return (e1.ymax - e2.ymax) / Math.abs(e1.ymax - e2.ymax);
  });

  if (!edges.length) {
    return lines;
  } // Start scanning


  var activeEdges = [];
  var y = edges[0].ymin;

  while (activeEdges.length || edges.length) {
    if (edges.length) {
      var ix = -1;

      for (var _i2 = 0; _i2 < edges.length; _i2++) {
        if (edges[_i2].ymin > y) {
          break;
        }

        ix = _i2;
      }

      var removed = edges.splice(0, ix + 1);
      removed.forEach(function (edge) {
        activeEdges.push({
          s: y,
          edge: edge
        });
      });
    }

    activeEdges = activeEdges.filter(function (ae) {
      if (ae.edge.ymax <= y) {
        return false;
      }

      return true;
    });
    activeEdges.sort(function (ae1, ae2) {
      if (ae1.edge.x === ae2.edge.x) {
        return 0;
      }

      return (ae1.edge.x - ae2.edge.x) / Math.abs(ae1.edge.x - ae2.edge.x);
    }); // fill between the edges

    if (activeEdges.length > 1) {
      for (var _i3 = 0; _i3 < activeEdges.length; _i3 = _i3 + 2) {
        var nexti = _i3 + 1;

        if (nexti >= activeEdges.length) {
          break;
        }

        var ce = activeEdges[_i3].edge;
        var ne = activeEdges[nexti].edge;
        lines.push([[Math.round(ce.x), y], [Math.round(ne.x), y]]);
      }
    }

    y += gap;
    activeEdges.forEach(function (ae) {
      ae.edge.x = ae.edge.x + gap * ae.edge.islope;
    });
  }

  return lines;
}